import { cn } from "@/lib/utils";
import type { IconComponent, ProviderIconProps } from "@/types/ui";
import { Broom, Building2, Droplets, Flame, Mail, Phone, Trash, Wifi, Zap } from "lucide-react";
import * as styles from "./ProviderIcon.styles";

const PROVIDER_ICONS: Record<string, IconComponent> = {
  Telemach: Wifi,
  Vodovod: Droplets,
  Elektroprivreda: Zap,
  Toplane: Flame,
  Oki: Broom,
  BhTelecom: Phone,
  BhTelecomEmail: Mail,
  Rad: Trash,
};

const getProviderIcon = (providerName: string): IconComponent => PROVIDER_ICONS[providerName] ?? Building2;

interface ProviderTileTone {
  bg: string;
  text: string;
}

const PROVIDER_TILE_TONES: Record<string, ProviderTileTone> = {
  Telemach: { bg: "bg-sky-500/10", text: "text-sky-500" },
  Vodovod: { bg: "bg-blue-500/10", text: "text-blue-500" },
  Elektroprivreda: { bg: "bg-amber-500/10", text: "text-amber-600" },
  Toplane: { bg: "bg-orange-500/10", text: "text-orange-500" },
  Oki: { bg: "bg-teal-500/10", text: "text-teal-500" },
  BhTelecom: { bg: "bg-purple-500/10", text: "text-purple-500" },
  BhTelecomEmail: { bg: "bg-pink-500/10", text: "text-pink-500" },
  Rad: { bg: "bg-emerald-500/10", text: "text-emerald-500" },
};

const getProviderTileTone = (providerName: string): ProviderTileTone =>
  PROVIDER_TILE_TONES[providerName] ?? { bg: "bg-muted", text: "text-muted-foreground" };

const ProviderIcon = ({ provider, size = "sm", className, title }: ProviderIconProps) => {
  const Icon = getProviderIcon(provider);
  const icon = <Icon className={cn(styles[size], className)} />;
  return title ? (
    <span className="inline-flex" title={title}>
      {icon}
    </span>
  ) : (
    icon
  );
};

export { PROVIDER_ICONS, PROVIDER_TILE_TONES, getProviderIcon, getProviderTileTone, ProviderIcon };
